export default {
    en: {
        Login: 'Login',
        LoginText: 'Welcome back, please login to your account.',
        Password: 'Password',
        RememberMe: 'Remember Me',
        ForgotPassword: 'Forgot Password?',
        Register: 'Register',
        ResetPass: 'Reset password',
        SendResetMail: 'Send request',
        ResetText: 'Mail with link and instructions has been sent to you!',
        PasswordReset: 'Password was changed successfully',
        Name: 'Name',
        LName: 'Last name',
        ConfirmPassword: 'Confirm password',
        VerificationEmailSent: 'Verification email has been sent!',
        ConfirmEmail: 'Email confirmation',
        ConfirmEmailText: 'Email address was confirm successfully!',
        ConfirmFailedText: 'Email address could not be confirmed!',
        Home: 'Home',
        Tasks: 'Tasks',
        AllTasks: 'All',
        Unassigned: 'Unassigned',
        Open: 'Open',
        InProgress: 'In progress',
        Waiting: 'Waiting',
        SentForConfirmation: 'Sent for confirmation',
        Confirmed: "Confirmed",
        DeniedLetter: 'D',
        DeniedReason: 'Denial reason:',
        TaskTitle: 'Task title',
        BranchOffice: 'Branch office',
        Status: 'Status',
        AssignedUser: 'Assigned user',
        Added: 'Added',
        Deadline: 'Deadline',
        Contact: 'Contact',
        Description: 'Description',
        Invoices: 'Invoices',
        Projects: 'Projects',
        ChangeTheme: 'Change theme',
        Logout: 'Logout',
        ProjectLeader: 'Project leader',
        TotalTasks: 'Total tasks',
        FinishedTasks: 'Finished tasks',
        CompletedPercent: 'Completed',
        OfferId: 'Offer ID',
        ProjectWaitingForUserConfirm: 'Waiting for project leader confirmation',
        ProjectWaitingForClientConfirm: 'Waiting for client confirmation',
        Data: 'Data',
        ProjectFinished: 'Projekt finished',
        Id: 'ID',
        DateFinished: 'Date',
        NumberOfTasks: 'Number of tasks',
        InvoiceFile: 'Invoice',
        Times: 'Times',
        Transport: 'Transport',
        TransportNames: 'Transport types',
        Kilometers: 'Kilometers',
        TotalTime: 'Total time',
        Preview: 'Preview',
        TaskIds: 'Task IDs',
        Date: 'Date',
        Size: 'Size',
        Files: 'Files',
        Finished: 'Finished',
        ApprovedBy: 'Approved by',
        OpenPrintout: 'Open printout',
        SubmitRequest: 'Submit request',
        Add: 'Add',
        TaskAddingFailed: 'Request adding failed',
        TasksAll: 'Open',
        TasksInConfirmation: 'In Confirmation',
        TasksFinished: 'Finished'
    },
    sl:{
        Login: 'Prijava',
        LoginText: 'Dobrodošel nazaj, prijavi se v svoj račun.',
        Password: 'Geslo',
        RememberMe: 'Zapomni si me',
        ForgotPassword: 'Pozabljeno geslo?',
        Register: 'Registracija',
        ResetPass: 'Spremeni geslo',
        SendResetMail: 'Pošlji zahtevo',
        ResetText: 'Mail z povezavo za spremembo gesla in navodili je bil poslan!',
        PasswordReset: 'Geslo je bilo uspešno spremenjeno',
        Name: 'Ime',
        LName: 'Priimek',
        ConfirmPassword: 'Potrdi geslo',
        VerificationEmailSent: 'Poslan je bil potrditveni email!',
        ConfirmEmail: 'Potrditev Email naslova',
        ConfirmEmailText: 'Email naslov je bil uspešno potrjen!',
        ConfirmFailedText: 'Email naslova ni bilo mogoče potrdit!',
        Home: 'Domov',
        Tasks: 'Nalogi',
        AllTasks: 'Vsi',
        Unassigned: 'Nedodeljen',
        Open: 'Dodeljen',
        InProgress: 'V delu',
        Waiting: 'Na čakanju',
        SentForConfirmation: 'V potrjevanju',
        Confirmed: "Potrjen",
        DeniedLetter: 'Z',
        DeniedReason: 'Razlog zavrnitve:',
        TaskTitle: 'Naslov naloga',
        BranchOffice: 'Poslovalnica',
        Status: 'Stanje',
        AssignedUser: 'Dodeljen',
        Added: 'Dodano',
        Deadline: 'Rok',
        Contact: 'Kontaktna oseba',
        Description: 'Opis',
        Invoices: 'Fakture',
        Projects: 'Projekti',
        ChangeTheme: 'Zamenjaj temo',
        Logout: 'Odjava',
        ProjectLeader: 'Vodja projekta',
        TotalTasks: 'Skupno nalogov',
        FinishedTasks: 'Zaključeni nalogi',
        CompletedPercent: 'Zaključeno',
        OfferId: 'Številka ponudbe',
        ProjectWaitingForUserConfirm: 'Čakanje na potrditev nosilca projekta',
        ProjectWaitingForClientConfirm: 'Čakanje na potrditev stranke',
        Data: 'Podatki',
        ProjectFinished: 'Projekt zaključen',
        Id: 'ID',
        DateFinished: 'Datum',
        NumberOfTasks: 'Število nalogov',
        InvoiceFile: 'Faktura',
        Times: 'Časi',
        Transport: 'Poti',
        TransportNames: 'Tipi poti',
        Kilometers: 'Kilometri',
        TotalTime: 'Skupni čas',
        Preview: 'Predogled',
        TaskIds: 'ID-ji nalogov',
        Date: 'Datum',
        Size: 'Veličina',
        Files: 'Datoteke',
        Finished: 'Zaključeno',
        ApprovedBy: 'Potrdil',
        OpenPrintout: 'Odpri izpis',
        SubmitRequest: 'Oddaj zahtevek',
        Add: 'Dodaj',
        TaskAddingFailed: 'Dodajanje zahtevka ni uspelo',
        TasksAll: 'Odprti',
        TasksInConfirmation: 'V potrjevanju',
        TasksFinished: 'Zaključeni'
    },
    fr: {
        Login: 'S\'identifier',
        LoginText: 'Bienvenue à nouveau, veuillez vous connecter à votre compte.',
        Password: 'Mot de passe',
        RememberMe: 'Souviens-toi de moi',
        ForgotPassword: 'Mot de passe oublié?',
        Register: 'S\'inscrire',
        ResetPass: 'Réinitialiser le mot de passe',
        SendResetMail: 'Envoyer une demande',
        ResetText: 'Un mail avec lien et instructions vous a été envoyé!',
        PasswordReset: 'Le mot de passe a été changé avec succès',
        Name: 'Nom',
        LName: 'Nom de famille',
        ConfirmPassword: 'Confirmez le mot de passe',
        VerificationEmailSent: 'Un e-mail de vérification a été envoyé!',
        ConfirmEmail: 'Confirmation de l\'émail',
        ConfirmEmailText: 'L\'adresse e-mail a été confirmée avec succès!',
        ConfirmFailedText: 'L\'adresse e-mail n\'a pas pu être confirmée!',
        Home: 'Accueil',
        Tasks: 'Tâches',
        AllTasks: 'Tout',
        Unassigned: 'Non attribué',
        Open: 'Ouvert',
        InProgress: 'En cours',
        Waiting: 'Attendre',
        SentForConfirmation: 'Envoyé pour confirmation',
        Confirmed: "Confirmé",
        DeniedLetter: 'D',
        DeniedReason: 'Raison du refus:',
        TaskTitle: 'Titre de la tâche',
        BranchOffice: 'Succursale',
        Status: 'Statut',
        AssignedUser: 'Utilisateur affecté',
        Added: 'Ajouté',
        Deadline: 'Date limite',
        Contact: 'Contact',
        Description: 'La description',
        Invoices: 'Factures',
        Projects: 'Projets',
        ChangeTheme: 'Change le thème',
        Logout: 'Se déconnecter',
        ProjectLeader: 'Chef de projet',
        TotalTasks: 'Tâches totales',
        FinishedTasks: 'Tâches terminées',
        CompletedPercent: 'Terminé',
        OfferId: 'ID de l\'offre',
        ProjectWaitingForUserConfirm: 'En attente de la confirmation du chef de projet',
        ProjectWaitingForClientConfirm: 'En attente de la confirmation du client',
        Data: 'Les données',
        ProjectFinished: 'Projet terminé',
        Id: 'ID',
        DateFinished: 'Date',
        NumberOfTasks: 'Nombre de tâches',
        InvoiceFile: 'Facture d\'achat',
        Times: 'Fois',
        Transport: 'Transport',
        TransportNames: 'Types de transport',
        Kilometers: 'Kilomètres',
        TotalTime: 'Temps total',
        Preview: 'Aperçu',
        TaskIds: 'ID de tâche',
        Date: 'Date',
        Size: 'Taille',
        Files: 'Files',
        Finished: 'Des dossiers',
        ApprovedBy: 'Approuvé par',
        OpenPrintout: 'Impression ouverte',
        SubmitRequest: 'Envoyer la demande',
        Add: 'Ajouter',
        TaskAddingFailed: 'Échec de l\'ajout de la demande',
        TasksAll: 'Ouvert',
        TasksInConfirmation: 'En Confirmation',
        TasksFinished: 'Fini'
    },
    de: {
        Login: 'Anmeldung',
        LoginText: 'Willkommen zurück, bitte melden Sie sich in Ihrem Konto an.',
        Password: 'Kennwort',
        RememberMe: 'Behalte mich in Erinnerung',
        ForgotPassword: 'Kennwort vergessen?',
        Register: 'Registrieren',
        ResetPass: 'Kennwort zurücksetzen',
        SendResetMail: 'Anfrage senden',
        ResetText: 'Mail mit Link und Anweisungen wurde an Sie gesendet!',
        PasswordReset: 'Kennwort wurde erfolgreich geändert',
        Name: 'Name',
        LName: 'Nachname',
        ConfirmPassword: 'Bestätige das Kennwort ',
        VerificationEmailSent: 'Bestätigungs-E-Mail wurde gesendet!',
        ConfirmEmail: 'Email Bestätigung',
        ConfirmEmailText: 'E-Mail-Adresse wurde erfolgreich bestätigt!',
        ConfirmFailedText: 'E-Mail-Adresse konnte nicht bestätigt werden!',
        Home: 'Home',
        Tasks: 'Aufgaben',
        AllTasks: 'Alle',
        Unassigned: 'Nicht zugewiesen',
        Open: 'Öffnen',
        InProgress: 'In Bearbeitung',
        Waiting: 'Warten',
        SentForConfirmation: 'Zur Bestätigung gesendet',
        Confirmed: "Bestätigt",
        DeniedLetter: 'D',
        DeniedReason: 'Verweigerungsgrund:',
        TaskTitle: 'Aufgabentitel',
        BranchOffice: 'Niederlassung',
        Status: 'Status',
        AssignedUser: 'Zugewiesener Benutzer',
        Added: 'Hinzugefügt',
        Deadline: 'Frist',
        Contact: 'Kontakt',
        Description: 'Beschreibung',
        Invoices: 'Rechnungen',
        Projects: 'Projekte',
        ChangeTheme: 'Thema ändern',
        Logout: 'Abmelden',
        ProjectLeader: 'Projektleiter',
        TotalTasks: 'Gesamtaufgaben',
        FinishedTasks: 'Fertige Aufgaben',
        CompletedPercent: 'Abgeschlossen',
        OfferId: 'Angebots-ID',
        ProjectWaitingForUserConfirm: 'Warten auf Bestätigung des Projektleiters',
        ProjectWaitingForClientConfirm: 'Warten auf Kundenbestätigung',
        Data: 'Daten',
        ProjectFinished: 'Projekt abgeschlossen',
        Id: 'ID',
        DateFinished: 'Datum',
        NumberOfTasks: 'Anzahl der Aufgaben',
        InvoiceFile: 'Rechnung',
        Times: 'Zeiten',
        Transport: 'Transport',
        TransportNames: 'Transportarten',
        Kilometers: 'Kilometer',
        TotalTime: 'Gesamtzeit',
        Preview: 'Vorschau',
        TaskIds: 'Aufgaben-IDs',
        Date: 'Datum',
        Size: 'Größe',
        Files: 'Dateien',
        Finished: 'Abgeschlossen',
        ApprovedBy: 'Genehmigt durch',
        OpenPrintout: 'Ausdruck öffnen',
        SubmitRequest: 'Anfrage einreichen',
        Add: 'Hinzufügen',
        TaskAddingFailed: 'Anforderung Hinzufügen hinzugefügt fehlgeschlagen',
        TasksAll: 'Öffnen',
        TasksInConfirmation: 'In Bestätigung',
        TasksFinished: 'Abgeschlossen'
    },
    hr: {
        Login: 'Prijava',
        LoginText: 'Dobrodošao natrag, prijavi se u svoj račun',
        Password: 'Lozinka',
        RememberMe: 'Zapamti me',
        ForgotPassword: 'Zaboravljena lozinka?',
        Register: 'Registracija',
        ResetPass: 'Promijeni lozinku',
        SendResetMail: 'Pošalji zahtijev',
        ResetText: 'Mail sa poveznicom za promijenu lozinke i uputama je poslan!',
        PasswordReset: 'Lozinka je uspiješno promijenjena',
        Name: 'Ime',
        LName: 'Prezime',
        ConfirmPassword: 'Potvrdi lozinku',
        VerificationEmailSent: 'Poslan je verifikacijski email!',
        ConfirmEmail: 'Potvrda email naziva',
        ConfirmEmailText: 'Email naziv je bio uspiješno potvrđen',
        ConfirmFailedText: 'Email naziv nije bilo moguće potvrditi',
        Home: 'Dom',
        Tasks: 'Zadaci',
        AllTasks: 'Svi',
        Unassigned: 'Nedodjeljeni',
        Open: 'Dodjeljeni',
        InProgress: 'U radu',
        Waiting: 'Na čekanju',
        SentForConfirmation: 'U potvrđivanju',
        Confirmed: "Potvrđeni",
        DeniedLetter: 'Z',
        DeniedReason: 'Razlog odbijanja',
        TaskTitle: 'Naziv zadatka',
        BranchOffice: 'Podružnica',
        Status: 'Stanje',
        AssignedUser: 'Dodjeljen',
        Added: 'Dodano',
        Deadline: 'Rok',
        Contact: 'Kontaktna osoba',
        Description: 'Opis',
        Invoices: 'Fakture',
        Projects: 'Projekti',
        ChangeTheme: 'Zamjeni temu',
        Logout: 'Odjava',
        ProjectLeader: 'Vođa projekta',
        TotalTasks: 'Skupni zadaci',
        FinishedTasks: 'Završeni zadaci',
        CompletedPercent: 'Zaključeno',
        OfferId: 'Broj ponude',
        ProjectWaitingForUserConfirm: 'Čekanje na potrvdu nositelja projekta',
        ProjectWaitingForClientConfirm: 'Čekanje na potvrdu stranke',
        Data: 'Podaci',
        ProjectFinished: 'Projekt završen',
        Id: 'ID',
        DateFinished: 'Datum',
        NumberOfTasks: 'Broj zadataka',
        InvoiceFile: 'Faktura',
        Times: 'Vrijeme',
        Transport: 'Put',
        TransportNames: 'Vrsta puta',
        Kilometers: 'Kilometri',
        TotalTime: 'Ukupno vrijeme',
        Preview: 'Pretpregled',
        TaskIds: 'ID-ji zadataka',
        Date: 'Datum',
        Size: 'Veličina',
        Files: 'Datoteke',
        Finished: 'Zaključeno',
        ApprovedBy: 'Potvrdio',
        OpenPrintout: 'Otvori ispis',
        SubmitRequest: 'Predaj zahtjev',
        Add: 'Dodaj',
        TaskAddingFailed: 'Dodavanje zahtjeva nije uspjelo',
        TasksAll: 'Otvori',
        TasksInConfirmation: 'U potvrđivanju',
        TasksFinished: 'Završeni'
    },
}
